import React, { useContext, useState, useEffect } from "react";

import {
  IconButton,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
  Stack,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
//Icons
import { AiOutlineDashboard } from "react-icons/ai";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SettingsIcon from "@mui/icons-material/Settings";
import { HiUserGroup } from "react-icons/hi2";
import { RiUserFollowFill } from "react-icons/ri";
import { BiSolidReport } from "react-icons/bi";
//Src
import "./menunavbar.scss";
import schoolLogo from "../Assets/favicon.ico";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";

const drawerWidth = 280;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  height: "100%",
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  height: "600px !important",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function MenuNavbar({ open, handleDrawerClose }) {
  let location = useLocation();
  const navigate = useNavigate();

  // ===================== Change Language ==========================
  const { language, setAlert, dispatch, role, changeLanguage } =
    useContext(AuthContext);
  const { t } = translateLauguage(language);

  let userLogin = JSON.parse(window.localStorage.getItem("logIn"));

  //======================= List Menu ====================
  const listMenu = userLogin?.role === "Teacher" ?
    [
      {
        title: t(`page-dashboard`),
        active: location?.pathname === "/dashboard" ? true : false,
        navigate: "/dashboard",
        icon: <DashboardIcon className="link-icon" />,
      },
      {
        title: t(`page-student`),
        active:
          location?.pathname === "/student" ||
            location?.pathname === "/student/student-detail"
            ? true
            : false,
        navigate: "/student",
        icon: <HiUserGroup className="link-icon" />,
      },
      {
        title: t(`page-attendance`),
        active:
          location?.pathname === "/attendance" ||
            location?.pathname === "/attendance/attendance-check"
            ? true
            : false,
        navigate: "/attendance",
        icon: <RiUserFollowFill className="link-icon" />,
      },

    ].filter(Boolean) : [
      {
        title: t(`page-dashboard`),
        active: location?.pathname === "/dashboard" ? true : false,
        navigate: "/dashboard",
        icon: <DashboardIcon className="link-icon" />,
      },
      {
        title: t(`page-student`),
        active:
          location?.pathname === "/student" ||
            location?.pathname === "/student/student-detail"
            ? true
            : false,
        navigate: "/student",
        icon: <HiUserGroup className="link-icon" />,
      },
      {
        title: t(`page-attendance`),
        active:
          location?.pathname === "/attendance" ||
            location?.pathname === "/attendance/attendance-check"
            ? true
            : false,
        navigate: "/attendance",
        icon: <RiUserFollowFill className="link-icon" />,
      },
      {
        title: t(`page-report`),
        active: location?.pathname === "/report" ? true : false,
        navigate: "/report",
        icon: <BiSolidReport className="link-icon-a" />,
      },
      {
        title: t(`page-setting`),
        active:
          location?.pathname === "/setting" ||
            location?.pathname === "/setting/user" ||
            location?.pathname === "/setting/academic-year" ||
            location?.pathname === "/setting/school" ||
            location?.pathname === "/setting/level" ||
            location?.pathname === "/setting/class" ||
            location?.pathname === "/setting/group"
            ? true
            : false,
        navigate: "/setting",
        icon: <SettingsIcon className="link-icon-a" />,
      },
    ].filter(Boolean)

  return (
    <Drawer variant="permanent" open={open} className="drawer-menu">
      <DrawerHeader sx={{ height: "178px !important" }}>
        <Button
          onClick={() => {navigate("/");handleDrawerClose();}}
          sx={{
            borderRadius: "50%",
            padding: 3.5,
            margin: 3,
            marginBottom: -1.5,
          }}
        >
          <img src={schoolLogo} alt="schoolLogo" width="50%" height="auto" />
        </Button>
      </DrawerHeader>

      <List className="list-menu" sx={{ marginTop: "25px" }}>
        {listMenu?.map((item, index) => {
          return (
            <ListItem
              key={index}
              className={
                item?.active ? "list-item-active" : "list-item"
              }
              disablePadding
              onClick={() => {
                navigate(`${item?.navigate}`);
                handleDrawerClose();
              }}
            >
              <ListItemButton className="list-item-button">
                <ListItemIcon className="list-item-icon">
                  {item?.icon}
                </ListItemIcon>
                <Typography className="list-item-text">{item?.title}</Typography>
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Drawer>
  );
}
